import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {getLocalizationService} from '~/shared/services/localisationService';
import warningIcon from '~/assets/images/icons/warningIcon.png';
import {media} from '~/shared/theme/media';

import {Body, ButtonsContainer, ActionButton, Disclaimer, Subtitle, TextBlock} from '../styled';

const StyledBody = styled(Body)`
  ${media.minLargeTablet`
    width: 500px;
    height: 453px;
    padding: 24px 32px;
  `}
`;

const StyledDisclaimer = styled(Disclaimer)`
  width: 300px;
`;

const StyledTextBlock = styled(TextBlock)`
  margin-top: 32px;
  gap: 8px;
  ${media.minLargeTablet`
    margin-top: 24px;
    flex: 1;
  `}
`;

const StyledImageWithAlt = styled(ImageWithAlt)`
  width: 150px;
  height: 150px;
  ${media.minLargeTablet`
    width: 200px;
    height: 200px;
  `}
`;

type FailureScreenProps = {
  onRetry: () => void;
  ctaText: string;
  subTitle: string;
};

const FailureScreen = ({onRetry, ctaText, subTitle}: FailureScreenProps) => {
  const {t} = getLocalizationService();

  return (
    <StyledBody data-test-id="convertLoyaltyBalanceModal_failureScreen" role="alert">
      <StyledImageWithAlt src={warningIcon} noAlt />
      <StyledTextBlock>
        <Subtitle id="modal-title">{t('oops_something_went_wrong')}</Subtitle>
        <StyledDisclaimer id="modal-content">{subTitle}</StyledDisclaimer>
      </StyledTextBlock>
      <ButtonsContainer>
        <ActionButton
          variant="primaryLarge"
          data-test-id="convertLoyaltyBalanceModal_retryButton"
          onClick={onRetry}
        >
          {ctaText}
        </ActionButton>
      </ButtonsContainer>
    </StyledBody>
  );
};

export default FailureScreen;
